import { render } from "./PassportNumber.vue?vue&type=template&id=47fe3b73"
import script from "./PassportNumber.vue?vue&type=script&lang=js"
export * from "./PassportNumber.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__